/* eslint-disable */
import { DatePicker } from "@mui/x-date-pickers";
import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import SearchIcon from "@mui/icons-material/Search";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import EditCalendarOutlinedIcon from "@mui/icons-material/EditCalendarOutlined";
import AllInboxOutlinedIcon from "@mui/icons-material/AllInboxOutlined";
import DoubleArrowOutlinedIcon from "@mui/icons-material/DoubleArrowOutlined";
import DoneAllOutlinedIcon from "@mui/icons-material/DoneAllOutlined";
import RemoveDoneOutlinedIcon from "@mui/icons-material/RemoveDoneOutlined";
import PlayCircleOutlineOutlinedIcon from "@mui/icons-material/PlayCircleOutlineOutlined";
import { useEffect, useState, useContext } from "react";
import { getCacheData } from "../../services/CacheService";
import { getAnteojosArreglos } from "../../services/ProduccionService";
import IniciarAnteojoArregloDialog from "./IniciarAnteojoArregloDialog";
import CambiarBandejaAnteojoArregloDialog from "./CambiarBandejaAnteojoArregloDialog";
import CambiarAreaAnteojoArregloDialog from "./CambiarAreaAnteojoArregloDialog";
import ActualizarAnteojoArregloDialog from "./ActualizarAnteojoArregloDialog";
import VerAnteojoArregloDialog from "./VerAnteojoArregloDialog";
import FinalizarAnteojoArregloDialog from "./FinalizarAnteojoArregloDialog";
import NoFinalizarAnteojoArregloDialog from "./NoFinalizarAnteojoArregloDialog";
import Message from "../../utils/Message";
import WaitingDialog from "../../utils/WaitingDialog";
import AuthContext from "../../contexts/AuthContext";

const initialSearchData = {
  areaProduccion: localStorage.getItem("id_area_deposito") || "",
  sucursalOrigen: "",
  anteojoArreglo: "todo",
  codigoAnteojoArreglo: "",
  bandeja: "",
  codigoGestionAtencion: "",
  apellidoCliente: "",
  nombreCliente: "",
  fechaCreacionDesde: null,
  fechaCreacionHasta: null,
  estadoActual: "todo",
  fechaEstadoDesde: null,
  fechaEstadoHasta: null,
  usuario: "",
};

const anteojoArregloOptions = [
  {
    id: "todo",
    descripcion: "Todos",
  },
  {
    id: "anteojo",
    descripcion: "Anteojos",
  },
  {
    id: "arreglo",
    descripcion: "Arreglos",
  },
];

const estadoOptions = [
  {
    id: "todo",
    descripcion: "Todos",
  },
  {
    id: "ok-para-produccion",
    descripcion: "Ok producción",
  },
  {
    id: "produccion",
    descripcion: "Producción",
  },
  {
    id: "finalizado",
    descripcion: "Finalizado",
  },
];

const nameItemsText = "Producción";
//
// ################################################################################
//
const ProduccionTable = () => {
  const [searchData, setSearchData] = useState(initialSearchData);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [totalRowsCount, setTotalRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [anteojosArreglosList, setAnteojosArreglosList] = useState([]);
  const [anteojoArreglo, setAnteojoArreglo] = useState("");
  const [areasProduccion, setAreasProduccion] = useState([]);
  const [areasSucursalOrigen, setAreasSucursalOrigen] = useState([]);
  const [idGestionAtencion, setIdGestionAtencion] = useState("");
  const [idGcAnteojoArreglo, setIdGcAnteojoArreglo] = useState("");
  const [codigoAnteojoArreglo, setCodigoAnteojoArreglo] = useState("");
  const [openIniciarAnteojoArregloDialog, setOpenIniciarAnteojoArregloDialog] = useState(false);
  const [openCambiarBandejaAnteojoArregloDialog, setOpenCambiarBandejaAnteojoArregloDialog] =
    useState(false);
  const [openCambiarAreaAnteojoArregloDialog, setOpenCambiarAreaAnteojoArregloDialog] =
    useState(false);
  const [openActualizarAnteojoArregloDialog, setOpenActualizarAnteojoArregloDialog] =
    useState(false);
  const [openVerAnteojoArregloDialog, setOpenVerAnteojoArregloDialog] = useState(false);
  const [openFinalizarAnteojoArregloDialog, setOpenFinalizarAnteojoArregloDialog] = useState(false);
  const [openNoFinalizarAnteojoArregloDialog, setOpenNoFinalizarAnteojoArregloDialog] =
    useState(false);
  const [bandeja, setBandeja] = useState("");
  const [rowSelectionModel, setRowSelectionModel] = useState([]);

  const { hasPermission } = useContext(AuthContext);
  const _iniciarProduccion = hasPermission("produccion-inicia-produccion");
  const _cambiarBandeja = hasPermission("produccion-cambia-bandeja");
  const _cambiarArea = hasPermission("produccion-cambia-area");
  const _actualizarAnteojoArreglo = hasPermission("produccion-anteojo-arreglo-actualiza-e");
  const _finalizarProduccion = hasPermission("produccion-finaliza");
  const _noFinalizarProduccion = hasPermission("produccion-no-finaliza");

  const tableColumns = [
    {
      field: "bandeja",
      headerName: "Bandeja",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.bandeja;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "codigo_anteojo_arreglo",
      headerName: "Código Ant/Arr",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo_anteojo_arreglo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "anteojo_arreglo",
      headerName: "Tipo",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.anteojo_arreglo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "codigo_gc",
      headerName: "Código GC",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo_gc;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "cliente",
      headerName: "Cliente",
      headerAlign: "center",
      align: "left",
      flex: 2,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.nombre_cliente + " " + params.row.apellido_cliente;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_corta_area_punto_venta",
      headerName: "Suc Origen",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_corta_area_punto_venta;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "fecha_creacion_gc",
      headerName: "Fecha Creación",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.fecha_creacion_gc;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "descripcion_corta_area_produccion",
      headerName: "Area actual",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_corta_area_produccion;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "estado",
      headerName: "Estado",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = "ERR";
        switch (params.row.estado) {
          case "ok-para-produccion":
            _val = "OK PRODUCCION";
            break;
          case "produccion-preparando":
            _val = "PREPARANDO  ";
            break;
          case "produccion":
            _val = "EN PRODUCCION";
            break;
          case "finalizado":
            _val = "FINALIZADO";
            break;
        }
        return _val;
      },
    },
    {
      field: "fecha_estado",
      headerName: "Fecha Estado",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.fecha_estado;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "left",
      flex: 1.5,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          {params.row.action_iniciar === true && _iniciarProduccion && (
            <Tooltip title="Iniciar">
              <IconButton
                size="small"
                aria-label="iniciar"
                onClick={() => handleAnteojoArreglo(params.row, "iniciar")}
              >
                <PlayCircleOutlineOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}

          {params.row.action_actualizar === true && _actualizarAnteojoArreglo && (
            <Tooltip title="Actualizar">
              <IconButton
                size="small"
                aria-label="actualizar"
                onClick={() => handleAnteojoArreglo(params.row, "actualizar")}
              >
                <EditCalendarOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}

          {params.row.action_pasar_otra_area === true && _cambiarArea && (
            <Tooltip title="Pasar a otra área">
              <IconButton
                size="small"
                aria-label="pasar-area"
                onClick={() => handleAnteojoArreglo(params.row, "pasar_otra_area")}
              >
                <DoubleArrowOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}

          {params.row.action_cambiar_bandeja === true && _cambiarBandeja && (
            <Tooltip title="Cambiar bandeja">
              <IconButton
                size="small"
                aria-label="cambiar-bandeja"
                onClick={() => handleAnteojoArreglo(params.row, "cambiar_bandeja")}
              >
                <AllInboxOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}

          {params.row.action_finalizar === true && _finalizarProduccion && (
            <Tooltip title="Finalizar">
              <IconButton
                size="small"
                aria-label="finalizar"
                onClick={() => handleAnteojoArreglo(params.row, "finalizar")}
              >
                <DoneAllOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}

          {params.row.action_no_finalizar === true && _noFinalizarProduccion && (
            <Tooltip title="No finalizado">
              <IconButton
                size="small"
                aria-label="no-finalizar"
                onClick={() => handleAnteojoArreglo(params.row, "no-finalizar")}
              >
                <RemoveDoneOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}

          {params.row.action_ver === true && (
            <Tooltip title="ver">
              <IconButton
                size="small"
                aria-label="ver"
                onClick={() => handleAnteojoArreglo(params.row, "ver")}
              >
                <RemoveRedEyeOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  const handlePaginationModelChange = (newModel) => {
    setCurrentPage(newModel.page);
    setRowsPerPage(newModel.pageSize);
  };

  const tableOptions = {
    rowHeight: 40,
    columnHeaderHeight: 45,
    paginationMode: "server",
    rowCount: totalRowsCount,
    paginationModel: {
      page: currentPage,
      pageSize: rowsPerPage,
    },
    onPaginationModelChange: handlePaginationModelChange,
    pageSizeOptions: [10, 20, 30],
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    loading: false,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
      MuiTablePagination: {
        labelRowsPerPage: "Filas:",
        labelDisplayedRows: ({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
      },
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    loadAreasProduccion();
    loadAreasSucursalOrigen();
  }, []);
  //
  // ################################################################################
  //
  useEffect(() => {
    load();
  }, [currentPage, rowsPerPage]);
  //
  // ################################################################################
  //
  const loadAreasProduccion = async () => {
    const response = await getCacheData('area');
    if (response.ok) {
      const _response = response.data.data.filter(area => area.actividad === "produccion");
      setAreasProduccion(_response);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadAreasSucursalOrigen = async () => {
    const response = await getCacheData('area');
    if (response.ok) {
      const _response = response.data.data.filter(area => area.actividad === "punto-de-venta" && area.interno_externo === "interno");
      setAreasSucursalOrigen(_response);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const load = async () => {
    let _params = {
      areaProduccion: searchData.areaProduccion,
      sucursalOrigen: searchData.sucursalOrigen,
      anteojoArreglo: searchData.anteojoArreglo,
      codigoAnteojoArreglo: searchData.codigoAnteojoArreglo,
      bandeja: searchData.bandeja,
      codigoGestionAtencion: searchData.codigoGestionAtencion,
      apellidoCliente: searchData.apellidoCliente,
      nombreCliente: searchData.nombreCliente,
      fechaCreacionDesde: searchData.fechaCreacionDesde,
      fechaCreacionHasta: searchData.fechaCreacionHasta,
      estadoActual: searchData.estadoActual,
      fechaEstadoDesde: searchData.fechaEstadoDesde,
      fechaEstadoHasta: searchData.fechaEstadoHasta,
      usuario: searchData.usuario,
      rows: rowsPerPage,
      first: currentPage * rowsPerPage,
    };

    setIsDoingSomething(true);
    const response = await getAnteojosArreglos(_params);
    setIsDoingSomething(false);

    if (response.ok) {
      setTotalRowsCount(response.data.count);
      setAnteojosArreglosList(response.data.data);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleBuscar = () => {
    load();
  };
  //
  // ################################################################################
  //
  const handleLimpiar = () => {
    setSearchData(initialSearchData);
    setAnteojosArreglosList([]);
    setTotalRowsCount(0);
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setSearchData({
      ...searchData,
      [e.target.name]: e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeFechaCreacionDesde = (parFecha) => {
    setSearchData({
      ...searchData,
      fechaCreacionDesde: parFecha,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeFechaCreacionHasta = (parFecha) => {
    setSearchData({
      ...searchData,
      fechaCreacionHasta: parFecha,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeFechaEstadoDesde = (parFecha) => {
    setSearchData({
      ...searchData,
      fechaEstadoDesde: parFecha,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeFechaEstadoHasta = (parFecha) => {
    setSearchData({
      ...searchData,
      fechaEstadoHasta: parFecha,
    });
  };
  //
  // ################################################################################
  //
  const handleAnteojoArreglo = (parRow, parAction) => {
    setAnteojoArreglo(parRow.anteojo_arreglo);
    setCodigoAnteojoArreglo(parRow.codigo_anteojo_arreglo);
    setIdGcAnteojoArreglo(parRow.id_gc_anteojo_arreglo);
    setIdGestionAtencion(parRow.id_gc);
    setBandeja(parRow.bandeja);

    if (parAction == "iniciar") {
      setOpenIniciarAnteojoArregloDialog(true);
    } else if (parAction == "cambiar_bandeja") {
      setOpenCambiarBandejaAnteojoArregloDialog(true);
    } else if (parAction == "pasar_otra_area") {
      setOpenCambiarAreaAnteojoArregloDialog(true);
    } else if (parAction == "actualizar") {
      setOpenActualizarAnteojoArregloDialog(true);
    } else if (parAction == "ver") {
      setOpenVerAnteojoArregloDialog(true);
    } else if (parAction == "finalizar") {
      setOpenFinalizarAnteojoArregloDialog(true);
    } else if (parAction == "no-finalizar") {
      setOpenNoFinalizarAnteojoArregloDialog(true);
    }
  };
  //
  // ################################################################################
  //
  const handleIniciaAnteojoArreglo = () => {
    setOpenIniciarAnteojoArregloDialog(false);
    load();
  };
  //
  // ################################################################################
  //
  const handleCloseIniciarAnteojoArregloDialog = () => {
    setOpenIniciarAnteojoArregloDialog(false);
  };
  //
  // ################################################################################
  //
  const handleCambiarBandeja = () => {
    setOpenCambiarBandejaAnteojoArregloDialog(false);
    load();
  };
  //
  // ################################################################################
  //
  const handleCloseCambiarBandejaDialog = () => {
    setOpenCambiarBandejaAnteojoArregloDialog(false);
  };
  //
  // ################################################################################
  //
  const handleCambiarArea = () => {
    setOpenCambiarAreaAnteojoArregloDialog(false);
    load();
  };
  //
  // ################################################################################
  //
  const handleCloseCambiarAreaDialog = () => {
    setOpenCambiarAreaAnteojoArregloDialog(false);
  };
  //
  // ################################################################################
  //
  const handleActualizarAnteojoArreglo = () => {
    setOpenActualizarAnteojoArregloDialog(false);
    load();
  };
  //
  // ################################################################################
  //
  const handleCloseActualizarAnteojoArregloDialog = () => {
    setOpenActualizarAnteojoArregloDialog(false);
  };
  //
  // ################################################################################
  //
  const handleCloseVerAnteojoArregloDialog = () => {
    setOpenVerAnteojoArregloDialog(false);
  };
  //
  // ################################################################################
  //
  const handleFinalizarAnteojoArreglo = () => {
    setOpenFinalizarAnteojoArregloDialog(false);
    load();
  };
  //
  // ################################################################################
  //
  const handleCloseFinalizarAnteojoArregloDialog = () => {
    setOpenFinalizarAnteojoArregloDialog(false);
  };
  //
  // ################################################################################
  //
  const handleNoFinalizarAnteojoArreglo = () => {
    setOpenNoFinalizarAnteojoArregloDialog(false);
    load();
  };
  //
  // ################################################################################
  //
  const handleCloseNoFinalizarAnteojoArregloDialog = () => {
    setOpenNoFinalizarAnteojoArregloDialog(false);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Paper elevation={1} >
          <Box sx={{ mx: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box sx={{ mt: 1 }} display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h5" display="cristal" gutterBottom >
                    {nameItemsText}
                  </Typography>
                </Box>
              </Grid>

              {areasProduccion.length > 0 && (
                <Grid item xs={12} md={12} lg={2}>
                  <FormControl sx={{ width: "100%" }}>
                    <InputLabel
                      id="area-produccion-select-label"
                      sx={{
                        transform: "translate(15px, 10px) scale(1)",
                        "&.MuiInputLabel-shrink": {
                          transform: "translate(14px, -8px) scale(0.75)", // Ajuste para cuando el label se reduce
                        },
                      }}
                    >
                      Area de Producción
                    </InputLabel>
                    <Select
                      labelId="area-produccion-select-label"
                      id="area-produccion-select"
                      name="areaProduccion"
                      value={searchData.areaProduccion}
                      label="Area de Producción"
                      size="small"
                      onChange={handleChange}
                      MenuProps={{ style: { maxHeight: "300px" } }}
                    >
                      {areasProduccion.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.descripcion}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}

              <Grid item xs={12} md={12} lg={2}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel
                    id="sucursal-origen-select-label"
                    sx={{
                      transform: "translate(15px, 10px) scale(1)",
                      "&.MuiInputLabel-shrink": {
                        transform: "translate(14px, -8px) scale(0.75)", // Ajuste para cuando el label se reduce
                      },
                    }}
                  >
                    Sucursal de Origen
                  </InputLabel>
                  <Select
                    labelId="sucursal-origen-select-label"
                    id="sucursal-origen-select"
                    name="sucursalOrigen"
                    value={searchData.sucursalOrigen}
                    label="Sucursal de origen"
                    size="small"
                    onChange={handleChange}
                    MenuProps={{ style: { maxHeight: "300px" } }}
                  >
                    {areasSucursalOrigen.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel id="anteojo-arreglo-select-label">Tipo</InputLabel>
                  <Select
                    labelId="anteojo-arreglo-select-label"
                    id="anteojo-arreglo-select"
                    name="anteojoArreglo"
                    value={searchData.anteojoArreglo}
                    label="Estado actual"
                    size="small"
                    onChange={handleChange}
                    MenuProps={{ style: { maxHeight: "300px" } }}
                  >
                    {anteojoArregloOptions.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="codigoAnteojoArreglo"
                  label="Código de Anteojo/Arreglo"
                  variant="outlined"
                  size="small"
                  name="codigoAnteojoArreglo"
                  value={searchData.codigoAnteojoArreglo}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="bandeja"
                  label="Bandeja"
                  variant="outlined"
                  size="small"
                  name="bandeja"
                  value={searchData.bandeja}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="codigoGestionAtencion"
                  label="Código de Gestion de Atención"
                  variant="outlined"
                  size="small"
                  name="codigoGestionAtencion"
                  value={searchData.codigoGestionAtencion}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="apellido"
                  label="Apellido de Cliente"
                  variant="outlined"
                  size="small"
                  name="apellidoCliente"
                  value={searchData.apellidoCliente}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="nombre"
                  label="Nombre de Cliente"
                  variant="outlined"
                  size="small"
                  name="nombreCliente"
                  value={searchData.nombreCliente}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <DatePicker
                  sx={{
                    width: "100%",
                    mb: 1,
                    "& .MuiInputLabel-root": {
                      transform: "translate(14px, 9px) scale(1)",
                    },
                    "& .MuiInputBase-root": {
                      paddingRight: "10px",
                    },
                    "& .MuiInputLabel-shrink": {
                      transform: "translate(14px, -8px) scale(0.75)",
                    },
                  }}
                  id="fechaCreacionDesde"
                  label="Desde fecha de creación"
                  variant="outlined"
                  name="fechaCreacionDesde"
                  value={searchData.fechaCreacionDesde}
                  format="dd/MM/yyyy"
                  maxDate={new Date()}
                  onChange={(fechaCreacionDesde) =>
                    handleChangeFechaCreacionDesde(fechaCreacionDesde)
                  }
                  slots={{ textField: TextField }}
                  slotProps={{
                    textField: {
                      size: "small",
                      variant: "outlined",
                      sx: { width: "100%", mr: 1 },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <DatePicker
                  sx={{
                    width: "100%",
                    mb: 1,
                    "& .MuiInputLabel-root": {
                      transform: "translate(14px, 9px) scale(1)",
                    },
                    "& .MuiInputBase-root": {
                      paddingRight: "10px",
                    },
                    "& .MuiInputLabel-shrink": {
                      transform: "translate(14px, -8px) scale(0.75)",
                    },
                  }}
                  id="fechaCreacionHasta"
                  label="Hasta fecha de creación"
                  variant="outlined"
                  name="fechaCreacionHasta"
                  value={searchData.fechaCreacionHasta}
                  format="dd/MM/yyyy"
                  maxDate={new Date()}
                  onChange={(fechaCreacionHasta) =>
                    handleChangeFechaCreacionHasta(fechaCreacionHasta)
                  }
                  slots={{ textField: TextField }}
                  slotProps={{
                    textField: {
                      size: "small",
                      variant: "outlined",
                      sx: { width: "100%", mr: 1 },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel id="estado-actual-select-label">Estado actual</InputLabel>
                  <Select
                    labelId="estado-actual-select-label"
                    id="estado-actual-select"
                    name="estadoActual"
                    value={searchData.estadoActual}
                    label="Estado actual"
                    size="small"
                    onChange={handleChange}
                    MenuProps={{ style: { maxHeight: "300px" } }}
                  >
                    {estadoOptions.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <DatePicker
                  sx={{
                    width: "100%",
                    mb: 1,
                    "& .MuiInputLabel-root": {
                      transform: "translate(14px, 9px) scale(1)",
                    },
                    "& .MuiInputBase-root": {
                      paddingRight: "10px",
                    },
                    "& .MuiInputLabel-shrink": {
                      transform: "translate(14px, -8px) scale(0.75)",
                    },
                  }}
                  id="fechaEstadoDesde"
                  label="Desde fecha de estado"
                  variant="outlined"
                  name="fechaEstadoDesde"
                  value={searchData.fechaEstadoDesde}
                  format="dd/MM/yyyy"
                  maxDate={new Date()}
                  onChange={(fechaEstadoDesde) => handleChangeFechaEstadoDesde(fechaEstadoDesde)}
                  slots={{ textField: TextField }}
                  slotProps={{
                    textField: {
                      size: "small",
                      variant: "outlined",
                      sx: { width: "100%", mr: 1 },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <DatePicker
                  sx={{
                    width: "100%",
                    mb: 1,
                    "& .MuiInputLabel-root": {
                      transform: "translate(14px, 9px) scale(1)",
                    },
                    "& .MuiInputBase-root": {
                      paddingRight: "10px",
                    },
                    "& .MuiInputLabel-shrink": {
                      transform: "translate(14px, -8px) scale(0.75)",
                    },
                  }}
                  id="fechaEstadoHasta"
                  label="Hasta fecha de estado"
                  variant="outlined"
                  name="fechaEstadoHasta"
                  value={searchData.fechaEstadoHasta}
                  format="dd/MM/yyyy"
                  maxDate={new Date()}
                  onChange={(fechaEstadoHasta) => handleChangeFechaEstadoHasta(fechaEstadoHasta)}
                  slots={{ textField: TextField }}
                  slotProps={{
                    textField: {
                      size: "small",
                      variant: "outlined",
                      sx: { width: "100%", mr: 1 },
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ mx: 1, mb: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="buscar">
                    <Button
                      fullWidth
                      variant="contained"
                      size="small"
                      onClick={handleBuscar}
                      startIcon={<SearchIcon />}
                    >
                      Buscar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="limpiar filtros">
                    <Button
                      fullWidth
                      variant="outlined"
                      size="small"
                      onClick={handleLimpiar}
                      startIcon={<CleaningServicesIcon />}
                    >
                      Limpiar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Paper>

        <DataGrid
          rows={anteojosArreglosList}
          columns={tableColumns}
          getRowId={(row) => row.id_gc_anteojo_arreglo}
          {...tableOptions}
        />
      </Paper>

      {openIniciarAnteojoArregloDialog && (
        <IniciarAnteojoArregloDialog
          anteojoArreglo={anteojoArreglo}
          codigoAnteojoArreglo={codigoAnteojoArreglo}
          idGcAnteojoArreglo={idGcAnteojoArreglo}
          onIniciarAnteojoArreglo={handleIniciaAnteojoArreglo}
          onClose={handleCloseIniciarAnteojoArregloDialog}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {openCambiarBandejaAnteojoArregloDialog && (
        <CambiarBandejaAnteojoArregloDialog
          idGestionAtencion={idGestionAtencion}
          anteojoArreglo={anteojoArreglo}
          codigoAnteojoArreglo={codigoAnteojoArreglo}
          idGcAnteojoArreglo={idGcAnteojoArreglo}
          onCambiarBandeja={handleCambiarBandeja}
          onClose={handleCloseCambiarBandejaDialog}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {openCambiarAreaAnteojoArregloDialog && (
        <CambiarAreaAnteojoArregloDialog
          idGestionAtencion={idGestionAtencion}
          anteojoArreglo={anteojoArreglo}
          codigoAnteojoArreglo={codigoAnteojoArreglo}
          idGcAnteojoArreglo={idGcAnteojoArreglo}
          onCambiarArea={handleCambiarArea}
          onClose={handleCloseCambiarAreaDialog}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {openActualizarAnteojoArregloDialog && (
        <ActualizarAnteojoArregloDialog
          idGestionAtencion={idGestionAtencion}
          anteojoArreglo={anteojoArreglo}
          codigoAnteojoArreglo={codigoAnteojoArreglo}
          idGcAnteojoArreglo={idGcAnteojoArreglo}
          onActualizarAnteojoArreglo={handleActualizarAnteojoArreglo}
          onClose={handleCloseActualizarAnteojoArregloDialog}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {openVerAnteojoArregloDialog && (
        <VerAnteojoArregloDialog
          idGestionAtencion={idGestionAtencion}
          anteojoArreglo={anteojoArreglo}
          codigoAnteojoArreglo={codigoAnteojoArreglo}
          idGcAnteojoArreglo={idGcAnteojoArreglo}
          onClose={handleCloseVerAnteojoArregloDialog}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {openFinalizarAnteojoArregloDialog && (
        <FinalizarAnteojoArregloDialog
          idGestionAtencion={idGestionAtencion}
          anteojoArreglo={anteojoArreglo}
          codigoAnteojoArreglo={codigoAnteojoArreglo}
          idGcAnteojoArreglo={idGcAnteojoArreglo}
          onFinalizarAnteojoArreglo={handleFinalizarAnteojoArreglo}
          onClose={handleCloseFinalizarAnteojoArregloDialog}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {openNoFinalizarAnteojoArregloDialog && (
        <NoFinalizarAnteojoArregloDialog
          idGestionAtencion={idGestionAtencion}
          anteojoArreglo={anteojoArreglo}
          idGcAnteojoArreglo={idGcAnteojoArreglo}
          bandejaActual={bandeja}
          onNoFinalizarAnteojoArreglo={handleNoFinalizarAnteojoArreglo}
          onClose={handleCloseNoFinalizarAnteojoArregloDialog}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default ProduccionTable;
